module.exports = __webpack_public_path__ + "static/media/footer-logo-web.7d9ae7b4.svg";